import { InterestRateModelPanelProps } from '../components/interest-rate-model-panel/InterestRateModelPanel'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'

export interface MakeInterestRateModelInfoParams {
  chainId: number
  reserve: Reserve
}

export function makeInterestRateModelInfo({
  chainId,
  reserve,
}: MakeInterestRateModelInfoParams): InterestRateModelPanelProps {
  return {
    interestRateStrategyAddress: reserve.interestRateStrategyAddress,
    chainId,
    utilizationRate: reserve.utilizationRate,
    variableRateSlope1: reserve.variableRateSlope1,
    variableRateSlope2: reserve.variableRateSlope2,
    baseVariableBorrowRate: reserve.baseVariableBorrowRate,
    optimalUtilizationRate: reserve.optimalUtilizationRate,
    totalLiquidity: reserve.totalLiquidity,
    totalDebt: reserve.totalDebt,
    reserveToken: reserve.token,
  }
}
